import { useParams, useNavigate } from 'react-router-dom';
import { useSeoMeta } from '@unhead/react';
import { AppShell } from '@/components/AppShell';
import { InfiniteFeed } from '@/components/feed';
import { useRelayFeed } from '@/hooks/useFeeds';
import { useFeed } from '@/contexts/FeedContext';
import { useSocial } from '@/contexts/SocialContext';

export function RelaySetPage() {
  const { id } = useParams<{ id: string }>();
  const { relaySets, setFeed } = useFeed();
  const { showReplies } = useSocial();
  const navigate = useNavigate();
  const set = relaySets.find((r) => r.id === id);

  useSeoMeta({
    title: set ? `${set.name} feed — Jumble` : 'Relay set — Jumble',
    description: set ? `Browse the ${set.name} relay set on Nostr.` : 'Browse a Nostr relay set.',
  });

  const feed = useRelayFeed(set?.relayUrls ?? [], { showReplies, enabled: !!set });

  if (!set) {
    return (
      <AppShell title="Relay set not found">
        <div className="p-8 text-center">
          <p className="text-muted-foreground">This relay set doesn't exist.</p>
          <button className="mt-2 underline" onClick={() => navigate('/')}>Go home</button>
        </div>
      </AppShell>
    );
  }

  return (
    <AppShell
      title={set.name}
      right={<span className="text-xs text-muted-foreground">{set.relayUrls.length} relays</span>}
    >
      <div className="border-b px-4 py-2 text-xs text-muted-foreground">
        Reading from {set.relayUrls.length} relays ·{' '}
        <button
          className="underline"
          onClick={() => { setFeed({ feedType: 'relays', id: set.id, name: set.name }); navigate('/'); }}
        >
          Make default feed
        </button>
      </div>
      <InfiniteFeed
        events={feed.events}
        isLoading={feed.isLoading}
        isFetchingNextPage={feed.isFetchingNextPage}
        hasNextPage={feed.hasNextPage}
        fetchNextPage={() => feed.fetchNextPage()}
      />
    </AppShell>
  );
}
